import React, { useRef, useEffect, useState } from 'react';
import { FaPhoneAlt } from "react-icons/fa";
import { FadeInFromBottomWhenVisible } from '../../utils/HomePageFadeEffects';
import { CONTACT_INFO } from '../../config/constants';

export default function CTASectionCard() {

  const phone = CONTACT_INFO.mainPhone;
  
  return (
   <section className="relative overflow-hidden bg-gradient-to-r from-sky-700 via-sky-800 
            to-sky-700 shadow-2xl py-14 sm:py-20 px-4 sm:px-12 rounded-sm flex items-center 
            justify-center min-h-[340px] sm:min-h-[300px] mx-auto select-none" >

   <FadeInFromBottomWhenVisible>
    <div className="w-full max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between 
    gap-8 sm:gap-14 text-left sm:text-center">
      <div className="flex-1">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-white mb-4 font-heading leading-tight 
        drop-shadow">
          Let’s be there for you,<br className="hidden sm:block"/> when seconds count.
        </h2>
        <p className="text-base sm:text-lg max-w-xl font-medium text-white/85 mb-6 sm:mb-0">
          Fast emergency response isn’t just a promise—it’s a guarantee. Our highly trained ambulance 
          teams and real-time tracking ensure care reaches you or your loved ones in critical moments.
          <br className="hidden sm:block"/>
          <span className="inline-block mt-2 sm:mt-3 text-sky-200 font-semibold">Trust compassion. Trust 
            speed. Trust us.</span>
        </p>
      </div>
      <div className="flex flex-col items-center gap-5">
        <a
          href={`tel:${phone}`}
          className="inline-flex bg-white text-sky-700 px-10 sm:px-14 py-4 items-center justify-center 
          gap-3 rounded-full font-bold text-lg shadow-lg hover:bg-sky-100/80 border border-sky-300 
          ocus:ring-2 focus:ring-sky-400 transition transform hover:scale-105"
          aria-label={`Call Madeshwara Ambulance at ${phone}`}
        >
          <FaPhoneAlt className="text-red-600 text-2xl animate-pulse" />
          <span className="tracking-widest">+91 {phone}</span>
        </a>
        <div className="text-xs text-white/70 font-semibold tracking-wide mt-1">24/7 Emergency Care 
        Hotline</div>
      </div>
    </div>
  </FadeInFromBottomWhenVisible>
</section>
  )
}


